import { AutocompleteRenderGetTagProps, Chip } from '@mui/material';
import AppSelect from 'components/AppSelect';
import { User } from 'types';

interface UserSelectProps {
  value: User[] | null;
  onChange: (users: User[]) => void;
  options: User[];
  error?: boolean;
  helperText?: string;
}

const UserSelect = ({ value, onChange, options, error, helperText }: UserSelectProps) => {
  // Получение выбранных пользователей для отображения
  const getSelectedUsers = (): User[] => {
    if (!value || !Array.isArray(value)) return [];
    return options.filter((option) => value.some((selectedUser) => selectedUser.id === option.id));
  };

  // Фильтруем опции, исключая уже выбранных пользователей
  const availableOptions = options.filter(
    (option) => !value?.some((selectedUser) => selectedUser.id === option.id)
  );

  const handleChange = (event: React.SyntheticEvent, newValue: User[]) => {
    onChange(newValue || []);
  };

  const renderTags = (value: User[], getTagProps: AutocompleteRenderGetTagProps) => {
    return value.map((user, index) => (
      <Chip {...getTagProps({ index })} key={user.id} label={user.name} size="small" />
    ));
  };

  // Функция для получения отображаемого текста пользователя
  const getUserDisplayText = (user: User) => {
    const rolesText = user.roles?.map((role) => role.title).join(', ');
    return rolesText
      ? `${user.name ? user.name : user.email} (${rolesText})`
      : user.name
        ? user.name
        : user.email;
  };

  return (
    <AppSelect<User, true>
      multiple
      options={availableOptions}
      getOptionLabel={(option) => getUserDisplayText(option)}
      value={getSelectedUsers()}
      onChange={handleChange}
      renderTags={renderTags}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      noOptionsText="Нет доступных пользователей"
      label="Пользователи"
      textFieldProps={{ error, helperText }}
    />
  );
};

export default UserSelect;
